export const SPORTS = [
  { value: 'flag', label: 'Flag' },
  { value: 'tackle', label: 'Tackle' }
];

export const DEFAULT_SPORT = 'flag';

const SPORT_ALIASES = {
  flag: 'flag',
  tackle: 'tackle',
  equipado: 'tackle'
};

export const normalizeSportValue = (value) => {
  if (!value) return DEFAULT_SPORT;
  const normalized = value.toString().trim().toLowerCase();
  return SPORT_ALIASES[normalized] || normalized;
};

export const getSportLabel = (value) => {
  if (!value) return 'Sin definir';
  const normalized = normalizeSportValue(value);
  const match = SPORTS.find((option) => option.value === normalized);
  return match ? match.label : value;
};
